module.exports = __webpack_public_path__ + "img/3绝缘材料.b051d7fd.jpg";